import Axios from "../utils/axiosInterceptor";
import { PATIENT_APIS } from "../utils/constants";
import { StatusCodes } from "http-status-codes";
export { fetchProcedures, fetchSpecialities } from "./patientService";

export const fetchEnhancementDataService = async (
  caseId: string | number,
  visitId: string | number,
): Promise<any> => {
  const response = await Axios.get(
    `${PATIENT_APIS.GET_ENHANCEMENT_DATA}/${caseId}/visitInfo/${visitId}/getAll`,
  );
  if (response.status === StatusCodes.OK) {
    return response.data;
  }
  throw new Error("Unable to fetch enhancement data");
};

export const PostEnhancementData = async (
  caseId: string | number,
  visitId: string | number,
  portalMetaDataId: string | number,
  payload: unknown,
) => {
  const response = await Axios.post(
    `${PATIENT_APIS.GET_ENHANCEMENT_DATA}/${caseId}/visitInfo/${visitId}/portalMetaData/${portalMetaDataId}/caseEnhancement`,
    payload,
  );
  return response;
};